import { makeVar } from '@apollo/client/core';

export const accessToken = makeVar('');
export const monthlyPayment = makeVar(0);
export const dateOfBirth = makeVar('');
export const portalApplicationId = makeVar(0);
export const cacChubSSNId = makeVar('');
